import { RouteObject } from 'react-router-dom';
import OptimizerPage from '../pages/OptimizerPage';
import HistoryPage from '@/modules/optimizer/pages/HistoryPage';
import CampaignGroupsPage from '../pages/CampaignGroupsPage';

export const OPTIMIZER_ROUTES: RouteObject[] = [
  {
    path: 'optimizer',
    children: [
      {
        index: true,
        element: <OptimizerPage />,
      },
    ],
  },
  {
    path: 'history',
    children: [
      {
        index: true,
        element: <HistoryPage />,
      },
    ],
  },
  {
    path: 'campaign-groups',
    children: [
      {
        index: true,
        element: <CampaignGroupsPage />,
      },
    ],
  },
];
